import React, { useState } from 'react'
import API from '../../utils/API'
import CheckEmailModal from './CheckEmailModal'
import { FormattedMessage } from 'react-intl';

function ForgotPassword(props) {
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  function handleSubmit() {
    API.emailResetPassword({ email })
      .then(res => {
        setSuccess(true);
        setError('');
      }).catch(err => {
        if(err.response && err.response.status === 400){
          setError(<FormattedMessage id={err.response.data}/>)
        }else{
          setError(<FormattedMessage id="SERVER_ERROR"/>)
        }
      })
  }

  return (
    <div>
      <div className='password container py-5 h-100'>
        <div className='row d-flex justify-content-center p-3'>
          <div className='col-xl-4'>
            <form>
              <div className='header text-center mb-4'>
                <h2><FormattedMessage id="FORGOT_PASSWORD_TITLE" /></h2>
              </div>
                {success ? 
                  <div className='card'>
                    <FormattedMessage id="FORGOT_PASSWORD_EMAIL_SENT" values={{email: email}}/>
                  </div> :
                    <div className='card'>
                      <div className='form-outline mb-4'>
                          <label className='form-label' id='emailAddressLabel' htmlFor='form2Example1'><FormattedMessage id="EMAIL_ADDRESS" /></label>
                          <input className='form-control rounded-1' id='emailAddressField' value={email} name='email' type='email' onChange={(e) => setEmail(e.target.value)} />
                      </div>
                      {error ? <p className='error'>{error}</p> : null}
                      <button type='button' className='btn btn-primary btn-block mb-1' data-bs-toggle="modal" data-bs-target="#checkEmailModal" onClick={handleSubmit}><FormattedMessage id="SUBMIT" /></button>
                      {/* <div><FormattedMessage id="FORGOT_PASSWORD_DECRIPTION" /></div> */}
                      {/* <div className='login-btn row text-center'>
                        <a href='../login'><FormattedMessage id="LOG_IN" /></a>
                      </div> */}
                    </div>
                }

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword